module.exports = "images/3ans.f15114a3.png";